import PropTypes from "prop-types";
import { Input } from "reactstrap";

import { H1, H2 } from "../../../../AbstractElements";
import FileHandler from "../../../../CommonElements/FileHandler";

const Dropdown = ({
  questionId,
  questionNumber,
  title,
  options,
  handleChange,
  isChecked,
  mediaUrl,
}) => (
  <div className="single-choise">
    <H1 className="single-choise__question">{questionNumber}</H1>
    <H2 className="single-choise__title">{title}</H2>
    {mediaUrl && <FileHandler showPreview={true} mediaUrl={mediaUrl} />}
    <Input
      type="select"
      className="form-control mt-2"
      value={
        options?.find(option => isChecked(option.option_id, questionId))
          ?.option_id || ""
      }
      onChange={e => handleChange(Number(e.target.value), questionId)}
    >
      <option value="">Select</option>
      {options?.map(option => (
        <option key={option.option_id} value={option.option_id}>
          {option.option_text}
        </option>
      ))}
    </Input>
  </div>
);

Dropdown.propTypes = {
  questionId: PropTypes.number.isRequired,
  questionNumber: PropTypes.string,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      option_id: PropTypes.number.isRequired,
      option_text: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
  mediaUrl: PropTypes.string,
};

export default Dropdown;
